import { Icon } from "next/dist/lib/metadata/types/metadata-types";
import { FunctionComponent } from "react";
import Link from "next/link";
import { IconType } from "react-icons";
import Image from "next/image";
import { ElementType } from "react";

interface LinkProps {
  href: string;
  title: string;
  display: string;
  Icon: React.ElementType;
  //isActive: (value: boolean) => void
}

const MainMenuItem: FunctionComponent<LinkProps> = ({
  href,
  title,
  display,
  Icon,
}) => {
  return (
    <li>
      <Link
        className="content-center gap-x-1 hidden lg:flex items-center align-middle justify-center uppercase text-sm md:text-lg leading-[1rem]"
        href={href}
        title={title}
      >
        {Icon && <Icon className="inline-block mr-1 w-4 h-4" />}{" "}
        <span className="leading-[0.8rem] inline-block">{display}</span>
      </Link>
    </li>
  );
};
export default MainMenuItem;
